import { render, staticRenderFns } from "./crearTarifaIvaModal.vue?vue&type=template&id=5b9dfebf"
import script from "./crearTarifaIvaModal.vue?vue&type=script&lang=js"
export * from "./crearTarifaIvaModal.vue?vue&type=script&lang=js"
import style0 from "./crearTarifaIvaModal.vue?vue&type=style&index=0&id=5b9dfebf&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports